import {ContractInformationResponseBodyV2} from '@dms/api/customer';

export const isContractNaturalPerson = (contract: ContractInformationResponseBodyV2) =>
  contract.legalForm === 'NATURAL_PERSON';
